module.exports = __webpack_public_path__ + "static/media/save.8857041b.svg";